export default __webpack_public_path__ + "static/media/icons8-event-accepted-100.9c4c734d.svg";